import { token } from '~/_v3/composables/useToken';

export const authTokenExists = () => {
	return token.value && token.value !== '';
};
